import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Login from "~/views/Login/Login"
import Inbox from "~/views/Inbox/Inbox"
import EntryDetail from "~/views/EntryDetail/EntryDetail"
import Admin from "~/views/Admin/Admin"
import Chat from "~/views/Chat/Chat"

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Inbox />} />
        <Route path="/entries/:id" element={<EntryDetail />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/chat" element={<Chat />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
